import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "VBZ",
  industry: IndustryEnum.Transport,
  name: "VBZ",
  slug: "vbz",
  ...colors,
  pictures: [
    { id: "vbz_bus_v1.png" },
    { id: "vbz_double_bus_v1.png" },
    { id: "vbz_tram_v1.png" },
    { id: "vbz_tram_long_v1.png" },
  ],
};
export default config;
